var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCompliancePreview(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 4,
    fill: "#2C2E85"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#F6F8F9",
    strokeWidth: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.996 7c-4.898 0-8.781 5.081-8.944 5.298a.258.258 0 0 0 0 .31c.163.217 4.046 5.298 8.944 5.298 4.899 0 8.782-5.081 8.945-5.298a.258.258 0 0 0 0-.31C21.778 12.082 17.895 7 12.996 7zm0 10.39c-4.174 0-7.713-4.082-8.409-4.937.695-.854 4.235-4.937 8.41-4.937 4.174 0 7.713 4.082 8.408 4.937-.694.855-4.234 4.937-8.409 4.937z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.996 9.517a2.94 2.94 0 0 0-2.936 2.936 2.94 2.94 0 0 0 2.936 2.936 2.94 2.94 0 0 0 2.937-2.936 2.94 2.94 0 0 0-2.937-2.936zm0 5.356a2.423 2.423 0 0 1-2.42-2.42 2.423 2.423 0 0 1 2.42-2.42 2.423 2.423 0 0 1 2.42 2.42 2.423 2.423 0 0 1-2.42 2.42z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompliancePreview);
export default __webpack_public_path__ + "static/media/compliance-preview.e4e5f387.svg";
export { ForwardRef as ReactComponent };